import { render, staticRenderFns } from "./Discounts.vue?vue&type=template&id=f50631a6&scoped=true"
import script from "./Discounts.vue?vue&type=script&lang=js"
export * from "./Discounts.vue?vue&type=script&lang=js"
import style0 from "./Discounts.vue?vue&type=style&index=0&id=f50631a6&prod&scoped=true&lang=css"
import style1 from "./Discounts.vue?vue&type=style&index=1&id=f50631a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50631a6",
  null
  
)

export default component.exports